<template>
  <div class="card__share _px-sm-4">
    <div class="d-flex align-center">
      <ShareNetwork
        @open="shareClick"
        class="sharing__item sharing_vk"
        network="VK"
        :url="fullPath"
        :title="$props.title"
        :description="$props.description"
        :quote="$props.title"
        :media="origin + $props.image"
      >
        <div class="card__btn vk">
          <img :src="require('@/assets/img/icons/vk_icon.svg')" alt="" />
        </div>
      </ShareNetwork>

      <ShareNetwork
        @open="shareClick"
        class="sharing__item sharing_tg"
        network="Telegram"
        :url="fullPath"
        :title="$props.title"
        :description="$props.description"
        :quote="$props.title"
        :media="origin + $props.image"
      >
        <div class="card__btn tg _ml-2">
          <img :src="require('@/assets/img/icons/tg_icon.svg')" alt="" />
          <!--https://t.me/share/url?url={url}&text={text}-->
        </div>
      </ShareNetwork>

      <ShareNetwork
        @open="shareClick"
        class="sharing__item sharing_ok"
        network="Odnoklassniki"
        :url="fullPath"
        :title="$props.title"
        :description="$props.description"
        :quote="$props.title"
        :media="origin + $props.image"
      >
        <div class="card__btn ok _ml-2">
          <img :src="require('@/assets/img/icons/ok_icon.svg')" alt="" />
        </div>
      </ShareNetwork>

      <div class="sharing__item sharing_copy" @click="copyLink(fullPath)">
        <div class="card__btn copy _ml-2">
          <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20 9.5H11C9.89543 9.5 9 10.3954 9 11.5V20.5C9 21.6046 9.89543 22.5 11 22.5H20C21.1046 22.5 22 21.6046 22 20.5V11.5C22 10.3954 21.1046 9.5 20 9.5Z"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M5 15.5H4C3.46957 15.5 2.96086 15.2893 2.58579 14.9142C2.21071 14.5391 2 14.0304 2 13.5V4.5C2 3.96957 2.21071 3.46086 2.58579 3.08579C2.96086 2.71071 3.46957 2.5 4 2.5H13C13.5304 2.5 14.0391 2.71071 14.4142 3.08579C14.7893 3.46086 15 3.96957 15 4.5V5.5"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div>

      <p class="card__btn-txt _mb-0 _ml-2">
        {{ $t('interface.video.share') }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'CardSharing',
  props: {
    title: String,
    description: String,
    image: String,
    url: String,
    analyticEventPrefix: String,
  },
  computed: {
    fullPath() {
      return document.location.origin + this.$props.url
    },
    origin() {
      return document.location.origin
    },
  },
  methods: {
    ...mapActions(['fetchAlerts']),
    copyLink(text) {
      const vm = this
      navigator.clipboard.writeText(text).then(
        function () {
          vm.fetchAlerts({
            alerts: 'Ссылка скопирована',
            type: 'notify',
          })
        },
        function (err) {
          console.error('Async: Could not copy text: ', err)
        }
      )
    },
    shareClick(data) {
      let social = {
        vk: 'vk',
        odnoklassniki: 'ok',
        telegram: 'tg',
      }
      if (this.$gtm && this.analyticEventPrefix) {
        this.$gtm.push({
          event: this.analyticEventPrefix + '_sharing_' + social[data],
          param_value: this.helpers.stripHtml(this.title),
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.card {
  &__btn {
    display: grid;
    place-items: center;
    width: 38px;
    height: 38px;
    border-radius: 50%;
    background-color: color(grey-second);
    transition: 0.3s;
    cursor: pointer;

    &-txt {
      color: color(grey-light);
    }

    &:hover {
      &.vk {
        background-color: #0a57ee;
      }

      &.tg {
        background-color: #228bd3;
      }

      &.ok {
        background-color: #ec7d08;
      }

      &.copy {
        background-color: #77bb2f;
      }
    }
  }
}
</style>
